// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Import AI service and Create Model - RD 
import {getAI, getGenerativeModel, GoogleAIBackend} from "firebase/ai";


import { getAuth } from "firebase/auth";

import { getFirestore } from "firebase/firestore";





// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAEhO1zF7fLspbRpboo_C2tFGQkbc_7B3k",
  authDomain: "bytebuddi-93a7d.firebaseapp.com",
  projectId: "bytebuddi-93a7d",
  storageBucket: "bytebuddi-93a7d.firebasestorage.app",
  messagingSenderId: "161285569358",
  appId: "1:161285569358:web:0cbb4ea44462c78d123c1f",
  measurementId: "G-ETPPPQ7TRD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const db = getFirestore(app);

export { db, auth };

// Initialize Gemini Developer API backend - RD
const ai = getAI(app, { backend: new GoogleAIBackend() });

// Create a generative model instance - RD
/* 
 Multiple model options. Gemini-2.5-flash supports 
 input: Text, Video, Audio, Images
 output: Text
*/
const model = getGenerativeModel(ai, { model: "gemini-2.5-flash"});

export { model, ai };

